export const consultingDealTypes = [
    {
        value: "",
        label: "Select",
        disabled: true,
    },
    {
        value: "BOV",
        label: "BOV",
    },
    {
        value: "Consulting Fee (Sale)",
        label: "Consulting Fee (Sale)",
    },
    {
        value: "Consulting Fee (Lease)",
        label: "Consulting Fee (Lease)",
    },
    {
        value: "Consulting Fee",
        label: "Consulting Fee",
    },
    {
        value: "Debt & Equity Fee",
        label: "Debt & Equity Fee",
    },
    {
        value: "Lease Termination Fee",
        label: "Lease Termination Fee",
    },
    {
        value: "Loan Placement",
        label: "Loan Placement",
    },
    {
        value: "Referral (Lease)",
        label: "Referral (Lease)",
    },
    {
        value: "Referral (Sale)",
        label: "Referral (Sale)",
    },
];
